import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { publicRoutes, authRoutes, ProductPage, OrderDetailPage } from "./routes.js";
import ProductReviewsPage from "@/pages/product/ProductReviewsPage.jsx";
import MainLayout from "@/layouts/MainLayout.jsx";
import AdminLoginPage from "@/pages/admin-login/AdminLoginPage.jsx";
import CustomerAuthGate from "@/components/CustomerAuthGate.jsx";
import {
    ADMIN_LOGIN_ROUTE,
    ADMIN_PROFILE_ROUTE,
    MAIN_ROUTE,
    ROLES
} from "./utils/constants.js";
import { ADMIN_PROFILE_DEFAULT_SECTION } from "./utils/profileMenus.js";
import { useAuth } from "@/auth/AuthContext.jsx";
import { isStaffRole } from "@/utils/staffAccess.js";

function ProtectedRoute({ children, allowedRoles }) {
    const { isAuthenticated, role } = useAuth();
    const location = useLocation();
    const isStaffGate = allowedRoles?.some((entry) => isStaffRole(entry))
        && !allowedRoles.includes(ROLES.CUSTOMER);

    if (!isAuthenticated) {
        if (isStaffGate) {
            return <Navigate to={ADMIN_LOGIN_ROUTE} replace />;
        }
        return <CustomerAuthGate returnTo={`${location.pathname}${location.search}`} />;
    }
    if (allowedRoles && !allowedRoles.includes(role)) {
        if (isStaffRole(role)) {
            return <Navigate to={`${ADMIN_PROFILE_ROUTE}?section=${ADMIN_PROFILE_DEFAULT_SECTION}`} replace />;
        }
        return <Navigate to={MAIN_ROUTE} replace />;
    }
    return children;
}

const shellPublicRoutes = publicRoutes.filter(({ path }) => path !== ADMIN_LOGIN_ROUTE);

export default function AppRouter() {
    return (
        <Routes>
            <Route path={ADMIN_LOGIN_ROUTE} element={<AdminLoginPage />} />

            <Route element={<MainLayout />}>
                {shellPublicRoutes.map(({ path, Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}
                {authRoutes.map(({ path, Component, roles }) => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <ProtectedRoute allowedRoles={roles}>
                                <Component />
                            </ProtectedRoute>
                        }
                    />
                ))}
                <Route
                    path="/orders/:orderId"
                    element={
                        <ProtectedRoute allowedRoles={[ROLES.CUSTOMER]}>
                            <OrderDetailPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/product/:id/reviews" element={<ProductReviewsPage />} />
            </Route>

            <Route path="*" element={<Navigate to={MAIN_ROUTE} replace />} />
        </Routes>
    );
}
